// Design tokens from the "Shoob Website v2" Figma (styles/globals.css), replicated
// as plain values so the shop-flow islands match the design without pulling in
// Tailwind/shadcn. Used by styles.js and galleryCss.js.
const tokens = {
  // Brand (CTA blue)
  brand: '#008fcf',
  brandHover: '#007ab8',
  brandDark: '#084074', // hero gradient end
  brandTint: '#e6f4fb', // light-blue surface (quick-buy / selected)
  brandBorder: '#b3ddf0',

  // Neutrals (shadcn-style)
  ink: '#030213', // primary near-black text / dark bars
  body: '#1f2430',
  muted: '#717182', // muted-foreground
  mutedSurface: '#ececf0',
  accentSurface: '#e9ebef',
  surface: '#ffffff',
  pageBg: '#f9fafb',
  border: 'rgba(0,0,0,0.1)',
  borderStrong: '#d1d5db',
  hairline: '#ececf0',

  // Status / accents
  danger: '#d4183d',
  dangerText: '#b91c1c',
  dangerSurface: '#fef2f2',
  dangerBorder: '#fecaca',
  success: '#059669',
  star: '#f59e0b',
  badgeText: '#92400e',
  badgeSurface: '#fef3c7',

  // Shape
  radius: 10, // 0.625rem
  radiusSm: 6,
  radiusLg: 14,
  pill: 999,
  shadowSm: '0 1px 3px rgba(0,0,0,.08)',
  shadowMd: '0 8px 24px rgba(0,0,0,.14)',
  shadowPanel: '-4px 0 24px rgba(0,0,0,.2)',

  // Tint for a brand-blue shadow on selected cards
  brandShadow: '0 2px 10px rgba(0,143,207,0.30)',
};

export default tokens;
